import { Box } from '@hivebrite/design-system/Box';

import type { UserBannerScreenUIProps } from 'hb-builder/components/BuilderComponents/block/UserBanner/types/userBannerScreenUIProps';
import {
  CircularProgressBarWrapper,
  ScreenUIBox,
  ScreenUIButton,
  ScreenUITitle,
  ScreenUIWrapper,
} from 'hb-builder/components/BuilderComponents/block/UserBanner/UserBannerLayout/styles';

import DumbRoundedAvatar from './DumbRoundedAvatar';

const UserBannerMediumScreenUI = ({
  buttonAccount,
  buttonEvent,
  buttonPortfolio,
  buttonPost,
  ChildrenComponent,
  dataTestId,
  headline,
  image,
  profileCompletion,
  profileCompletionRate,
  shouldShowCompletionRate,
}: UserBannerScreenUIProps) => (
  <ScreenUIWrapper data-testid={dataTestId}>
    <Box alignItems="center">
      <Box alignItems="center" justifyContent="center">
        {shouldShowCompletionRate && !image?.attributes?.hidden && (
          <CircularProgressBarWrapper
            position="absolute"
            maxWidth="inherit"
            percentage={profileCompletionRate}
            size={56}
            strokeWidth={2}
          />
        )}
        <DumbRoundedAvatar image={image} />
      </Box>
      <ScreenUIBox>
        <ScreenUITitle>
          <ChildrenComponent item={{ children: [headline] }} />
        </ScreenUITitle>

        <Box mt="2px">
          <ChildrenComponent item={{ children: [profileCompletion] }} />
        </Box>
      </ScreenUIBox>
    </Box>

    <Box mt={3} flexDirection="column" alignItems="baseline">
      <ScreenUIButton m="inherit">
        <ChildrenComponent
          item={{
            children: [buttonPost, buttonEvent, buttonPortfolio, buttonAccount],
          }}
        />
      </ScreenUIButton>
    </Box>
  </ScreenUIWrapper>
);

export default UserBannerMediumScreenUI;
